// extracted by mini-css-extract-plugin
module.exports = {"content":"TripCartDrawer_content__zHI7e","fade-in":"TripCartDrawer_fade-in__aFBF_"};